import { FC } from "react"
import { Outlet, useLocation } from "react-router-dom";
import { CommonHeader } from "../parts/CommonHeader";
import { isHeritageClause } from "typescript";
import { CommonFooter } from "../parts/CommonFooter";
import { DesktopSideNav } from "../parts/DesktopSideNav";

export const MainLayout: FC = () => {
  const location = useLocation();
  const showSideNav = location.pathname !== "/";

  return  <>
    <div className="">
      <CommonHeader />
      <div className="w-full sm:flex">
        {showSideNav && <DesktopSideNav />}
        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
      </div>
      <CommonFooter />
    </div>
  </>
}
